import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3129, { U3129ROLES } from "./U3129";
import U3129TimesheetList from "./components/list/U3129TimesheetList";
import U3129TimesheetForm from "./components/form/U3129TimesheetForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3129Routes: RouteObject[] = [
  {
    path: "U3129",
    element: <U2000RequireRole allowedRoles={[U3129ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3129 />,
        children: [
          { index: true, element: <U3129TimesheetList /> },
          { path: "create", element: <U3129TimesheetForm /> },
          { path: ":id", element: <U3129TimesheetForm /> },
        ],
      },
    ],
  },
];

export default U3129Routes;
